import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=87a9b436&scoped=true"
import script from "./notice.vue?vue&type=script&lang=js"
export * from "./notice.vue?vue&type=script&lang=js"
import style0 from "./notice.vue?vue&type=style&index=0&id=87a9b436&prod&lang=scss"
import style1 from "./notice.vue?vue&type=style&index=1&id=87a9b436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a9b436",
  null
  
)

export default component.exports